import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';
import AppHeader from './layout/AppHeader.jsx';

const NAV = [
  { to: '/finance/coa', label: 'Chart of Accounts', perm: ['account', 'list'] },
  { to: '/finance/journal', label: 'Journal Entries', perm: ['journal_entry', 'list'] },
  { to: '/finance/ledger', label: 'Ledger', perm: ['journal_entry', 'read'] },
  { to: '/finance/vendors', label: 'Vendors', perm: ['vendor', 'list'] },
  { to: '/finance/vendor-invoices', label: 'Vendor Invoices', perm: ['vendor_invoice', 'list'] },
  { to: '/finance/customers', label: 'Customers', perm: ['customer', 'list'] },
  { to: '/finance/customer-invoices', label: 'Customer Invoices', perm: ['customer_invoice', 'list'] },
  { to: '/finance/payments', label: 'Payments', perm: ['payment', 'list'] },
  { to: '/finance/budgets', label: 'Budgets', perm: ['budget', 'list'] },
  { to: '/finance/banking', label: 'Banking', perm: ['bank_account', 'list'] },
  { to: '/finance/reports', label: 'Reports', perm: ['financial_report', 'read'] },
];

export default function FinanceShell() {
  const { can, roles } = useAuth();
  const visible = NAV.filter((n) => roles.includes('super_admin') || can(n.perm[0], n.perm[1]));

  return (
    <div className="hr-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Finance</div>
          <ul>
            {visible.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} className={({ isActive }) => (isActive ? 'active' : '')}>
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
